const account: AuthRoute.Route = {
  name: 'account',
  path: '/account',
  component: 'basic',
  meta: {
    title: '个人中心',
    icon: 'ic:outline-person-outline',
    order: 2,
    hide: true
  },
  children: [
    {
      name: 'account_personal',
      path: '/account/personal',
      component: 'self',
      meta: {
        title: '个人配置',
        requiresAuth: true,
        icon: 'ic:outline-manage-accounts'
      }
    }
  ]
};

export default account;
